import { Component } from '@theme/component';

class FrestFeaturedSlider extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#initialize();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    this.observer?.disconnect();
  }

  #initialize() {
    this.controller?.abort();
    this.observer?.disconnect();
    const track = this.querySelector('[data-featured-track]');
    const previous = this.querySelector('[data-featured-previous]');
    const next = this.querySelector('[data-featured-next]');
    if (!track || !previous || !next) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    const update = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const scrollPosition = Math.abs(track.scrollLeft);
      previous.disabled = scrollPosition <= 2;
      next.disabled = scrollPosition >= maxScroll - 2;
      this.classList.toggle('frest-home__featured-slider--static', maxScroll <= 2);
    };
    const scroll = (direction) => {
      const firstTile = track.querySelector('.frest-home__hero-tile');
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const step = firstTile ? firstTile.getBoundingClientRect().width + gap : track.clientWidth;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const flowDirection = styles.direction === 'rtl' ? -1 : 1;
      track.scrollBy({ left: direction * step * flowDirection, behavior: reducedMotion ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => scroll(-1), { signal });
    next.addEventListener('click', () => scroll(1), { signal });
    track.addEventListener('scroll', update, { passive: true, signal });
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
    } else {
      window.addEventListener('resize', update, { passive: true, signal });
    }
    update();
  }
}

if (!customElements.get('frest-featured-slider')) {
  customElements.define('frest-featured-slider', FrestFeaturedSlider);
}
